"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var context_1 = require("../../context");
var Client_1 = require("../Client");
var ClientFormInfo = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(__1.Card, null,
        react_1.default.createElement("div", { className: "mb-8" },
            react_1.default.createElement(Client_1.ClientNameAndUid, { name: client.name, uid: client.uid })),
        react_1.default.createElement(__1.DataRow, { label: trans('optiiva::labels.phone-number'), value: client.phone_number }),
        client.secondary_phone_number && (react_1.default.createElement(__1.DataRow, { label: trans('optiiva::labels.phone-number-secondary'), value: client.secondary_phone_number })),
        react_1.default.createElement(__1.DataRow, { label: trans('optiiva::labels.email'), value: client.email }),
        react_1.default.createElement(__1.DataRow, { dropBorder: true, flush: true, label: trans('optiiva::labels.address'), value: react_1.default.createElement(Client_1.FormattedAddress, { client: client }) })));
};
exports.default = ClientFormInfo;
//# sourceMappingURL=ClientFormInfo.js.map